import styled from "styled-components";

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
})



export const ToInteger = (value: any, noValue: any = null) =>{
  if(value === null || typeof value === 'string'){
    return noValue;
  }
  return Math.floor(value);
  
}